import React from 'react';
import PropTypes from 'prop-types';
import NextScript from 'next/script';
import { isValidUuid } from '../../utils/utility';

/**
 * @summary Renders a Cheetah Experiences / WayIn widget.
 * 
 * Please note that `htmlToReact` intercepts the main embed script and replaces
 * it with this React component because the main embed script uses `document.write`.
 * This React component reproduces the main embed script without using `document.write`.
 * @param {object} props
 * @param {string} props.uuid UUID of the WayIn widget. 
 * @returns {JSX.Element}
 */
export default function WayIn({ uuid }) {
	return isValidUuid(uuid) ? (
		<div id={`wayin-${uuid}`}>
			<NextScript
				type="text/javascript"
				src="https://s.wayin.com/ui/ngx.embed.min.js"
				strategy="beforeInteractive"
			/>
			<iframe
				title="WayIn embed"
				src={`https://xd.wayin.com/display/container/dc/${uuid}`}
				frameBorder="0"
				scrolling="no"
				width="100%"
				height="250"
				id={`ngxFrame${uuid}`}
				allowtransparency="true"
			/>
		</div>
	) : (
		<></>
	);
}

WayIn.propTypes = {
	uuid: PropTypes.string.isRequired,
};
